<div class="fs-2 success with-close" mat-dialog-title>
    Abonnement validé
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b>Félicitations, vous êtes officiellement un membre de la team LyBox !</b>
    <br/>
    <p class="text-center mt-4 mb-4">
        <img src="assets/party%20popper.png">
    </p>
    <p>Vous avez dès maintenant accès à toutes les fonctionnalités de votre forfait {{data.plan}} !</p>
    <p class="mb-0">Il est temps de trouver des biens rentables 🏢</p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline w-100">
        Fermer
    </button>
</div>
